import '../css/main.scss';

import $ from 'jquery';
import 'slick-carousel';
import './widgets/parallax.js';

import {ScrollToWidget, ToggleClassWidget} from './widgets/index';

import throttle from 'lodash/throttle';
import {DeviceMatcher} from './utilities/sink';

class HeaderComponent {
	init() {
		if (!DeviceMatcher.isSmallSizeDevice()) {
			let sticky = $('.site-header');
			$(window).scroll(throttle((e) => {
				let scroll = $(window).scrollTop();

				if (scroll >= 120) sticky.addClass('site-header--is-sticky');
				else sticky.removeClass('site-header--is-sticky');
			}, 50));
		}
	}
}

let header = new HeaderComponent();
header.init();

// init widgets
let widgets = [new ScrollToWidget('[data-init-scroll-to]'), new ToggleClassWidget('[data-init-toggle-class]')];

// ce image grid sliders
($('.ce-image-grid--slider > div') as any).slick({
	slidesToShow: 7.3,
	slidesToScroll: 5,
	swipeToSlide: true,
	arrows: false,
	dots: true,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 5
			}
		},
		{
			breakpoint: 900,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			}
		},
		{
			breakpoint: 700,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		}
	]
});


class CeHeaderStageComponent {
	public lFollowX: number = 0;
	public lFollowY: number = 0;
	public x: number = 0;
	public y: number = 0;
	public friction: number = 1 / 30;
	public fpsInterval: number = 10;
	public lastTick = Date.now();

	init() {
		if (!DeviceMatcher.isSmallSizeDevice()) {
			$(window).on('mousemove', throttle((e) => {
				let lMouseX = Math.max(-100, Math.min(100, $(window).width() / 2 - e.clientX));
				let lMouseY = Math.max(-100, Math.min(100, $(window).height() / 2 - e.clientY));
				this.lFollowX = (50 * lMouseX) / 100;
				this.lFollowY = (50 * lMouseY) / 100;
			}, 150));

			this.startAnimation();
		}
	}

	startAnimation() {
		this.animate();
	}

	animate() {

		window.requestAnimationFrame(this.animate.bind(this));

		let now = Date.now();
		let elapsed = now - this.lastTick;

		if (elapsed > this.fpsInterval) {

			this.lastTick = now - (elapsed % this.fpsInterval);

			this.x += (this.lFollowX - this.x) * this.friction;
			this.y += (this.lFollowY - this.y) * this.friction;

			let translate = 'translate(' + this.x + 'px, ' + this.y + 'px) scale(1.1)';

			$('.ce-header-stage .ce-header-stage__bg').css({
				'-webit-transform': translate,
				'-moz-transform': translate,
				'transform': translate
			});
		}
	}
}

let chsc = new CeHeaderStageComponent();
chsc.init();


// WEBPACK FOOTER //
// ./src/js/main.tsx